import React from 'react';
import {Stack, Typography, Box} from '@mui/material';
import {NavigationControls} from '../common/NavigationControls';
import {ProgressIndicator} from '../common/ProgressIndicator';
import {getHealthFunctions} from '../../utils/healthCalculations';

export const ResultsHeader = ({
  organization,
  headerData,
  features,
  onBackClick,
  onNextClick,
  isLargeScreen = false,
}) => {
  const healthFunctions = getHealthFunctions(headerData.name);
  const statusColor = healthFunctions.getColor(headerData.value);
  const statusText = healthFunctions.getStatus(headerData.value);
  const paramValue = healthFunctions.getScaledValue(headerData.value);

  const isProductPage = headerData.name === 'Top Products for You' || headerData.name === 'Recommended Lab Tests';
  const shouldBlur = features.blurCategories?.includes(headerData.name) && !headerData.isShowAllResultsCard;

  if (isLargeScreen) {
    return (
      <Stack>
        {/* Navigation Bar */}
        <Stack direction="row" justifyContent="space-between" padding="16px 0px 8px 0px">
          <NavigationControls
            onBack={onBackClick}
            onNext={onNextClick}
            config={organization.config}
            showBack={!organization.flags.isDoktor}
          />
        </Stack>

        {/* Header Content */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          paddingX="50px"
          paddingBottom={isProductPage ? '30px' : undefined}
        >
          <Stack>
            <Typography variant="h4" fontWeight="bold" sx={{fontSize: '23px'}}>
              {headerData.name}
            </Typography>

            {!isProductPage && (
              <Typography
                variant="p"
                fontWeight="600"
                sx={{
                  fontSize: '15px',
                  color: statusColor,
                  filter: shouldBlur ? 'blur(6px)' : 'blur(0px)',
                }}
              >
                {statusText}
              </Typography>
            )}

            {isProductPage && (
              <Typography sx={{color: '#545454', fontSize: '15px', fontWeight: 600}}>
                {headerData.name === 'Recommended Lab Tests'
                  ? 'Our recommended lab tests based on your results.'
                  : 'Our recommendations to elevate your health in your weakest health categories.'}
              </Typography>
            )}
          </Stack>

          {!isProductPage && (
            <ProgressIndicator value={paramValue} size={80} thickness={8} color={statusColor} blurred={shouldBlur} />
          )}
        </Stack>
      </Stack>
    );
  }

  // Mobile header is integrated into each slide component
  return null;
};
